/** In seconds */
export const CLASS_END_TIME_OFFSET = 5 * 60;
